import { FC, ReactNode } from 'react';

interface Props {
   children: ReactNode;
}

export const Sublevel: FC<Props> = ({ children }) => (
   <div className="px-component-input-sublevel-form-container-spacing-padding-x py-component-input-sublevel-form-container-spacing-padding-y bg-component-input-sublevel-form-container-color-background rounded-component-input-sublevel-form-container-border-radius flex flex-col">{children}</div>
);
